import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitCustomZoneModel } from '@apps-common/types/portal/unit'

export const QUERY_GET_UNIT_CUSTOM_ZONES = (unitId?: string) => ['getUnitCustomZones', unitId]

const getUnitCustomZones = async (unitId: string): Promise<IUnitCustomZoneModel[]> =>
  axios.get(`/unit/getcustomzones?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitCustomZones

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useGetUnitCustomZones = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_UNIT_CUSTOM_ZONES(unitId),
    queryFn: () => getUnitCustomZones(unitId)
  })
